import { useForm } from "react-hook-form";
import { TopicService } from "../../service/Topic/topic.service";
import { ITopicCreateProps, ITopicFormInput } from "./Topic.model";
import TopicForm from "./_topicForm";

const TopicCreate = ({ setTopicDialog, loadTopics }: ITopicCreateProps) => {
  const methods = useForm<ITopicFormInput>({
    mode: "onSubmit",
    defaultValues: {
      name: "",
      description: "",
      is_active: true,
    },
  });

  const { setError } = methods;

  const onSubmit = async (data: ITopicFormInput) => {
    try {
      await TopicService.create(data);
      loadTopics();
      setTopicDialog(false);
    } catch (err: any) {
      if (err.response?.data) {
        const errors = err.response.data;

        Object.keys(errors).forEach((key) => {
          setError(key as keyof ITopicFormInput, {
            type: "server",
            message: Array.isArray(errors[key]) ? errors[key][0] : errors[key],
          });
        });
      }
    }
  };

  return <TopicForm methods={methods} onSubmit={onSubmit} isEdit={false} />;
};

export default TopicCreate;
